import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-dad06003.js";
const c = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10L7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z",
  clipRule: "evenodd"
}, null, -1), s = [
  l
];
function _(i, d) {
  return e(), o("svg", r, s);
}
const m = /* @__PURE__ */ n(c, [["render", _]]);
export {
  m as default
};
